import { clomp } from 'clomp';

export const Flex = clomp.div`
  flex
`;
